import * as React from "react";
import { updateUrlWithoutReload } from "../../../../utils/utils/update-url.js";
import { getUpdatedUrlWithQueryParams, removeQueryParamsFromUrl } from "../../../../utils/utils/get-updated-url-with-query-params.js";
const useHandleQueryParams = () => {
  const updateUrlQueryParam = React.useCallback((params) => {
    updateUrlWithoutReload(getUpdatedUrlWithQueryParams(params));
  }, []);
  const deleteQueryParam = React.useCallback((params) => {
    updateUrlWithoutReload(removeQueryParamsFromUrl(params));
  }, []);
  return [updateUrlQueryParam, deleteQueryParam];
};
export {
  useHandleQueryParams
};
//# sourceMappingURL=use-handle-query-params.js.map
